import React from "react";
import { TitleHolder } from "../../../common/sharedComponents/styles/card.style";
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";

import UserTableContent from "./components/userTableContent";
import { StepperContentHolder } from "../../vendorRegistration/vendorRegistration";
import { Add, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { history } from "../../../app/history";
import { support_role_endpoint } from "../../../utilities/redux-api/endpoint";

const UserTable = () => {
  const [search, setSearch] = React.useState(null);
  return (
    <div>
      <TitleHolder>
        <Grid container>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Users
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "end", gap: "1rem" }}
          >
            <Grid
              item
              sx={{ display: "flex", gap: "1rem", alignItems: "center" }}
            >
              <TextField
                variant="standard"
                size="small"
                label="Search by Email & Company name"
                onChange={(e) => setSearch(e.target.value)}
              />
            </Grid>
            <Grid
              item
              sx={{ display: "flex", gap: "1rem", alignItems: "center" }}
            >
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Tooltip title="Other Options">
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: "2rem",
                          height: "2.5rem",
                          width: "4.3rem",
                        }}
                        {...bindTrigger(popupState)}
                      >
                        {popupState?.isOpen ? (
                          <KeyboardArrowDown />
                        ) : (
                          <KeyboardArrowUp />
                        )}
                      </Button>
                    </Tooltip>
                    <Menu {...bindMenu(popupState)}>
                      <MenuItem
                        onClick={() =>
                          history.push(`/app/${support_role_endpoint.user}/add`)
                        }
                      >
                        {<Add color="primary" />} Create User
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState>
            </Grid>
          </Grid>
        </Grid>
      </TitleHolder>
      <StepperContentHolder>
        <UserTableContent search={search} />
      </StepperContentHolder>
    </div>
  );
};

export default UserTable;
